//state for app runing variable

const state = {
    // application running state variable
    appIsRunning: false,
    // page scrolling state variable
    appScroll: false,
    isMobile: window.innerWidth <= 767,
    fontSize: 'default'
}

const getters = {
    // getter for application runing state
    GET_APP_IS_RUNNING: state => {
        return state.appIsRunning
    },
    // getter for application scrolling state
    GET_APP_SCROLL: state => {
        return state.appScroll
    },
    // current font size
    GET_FONT_SIZE: state => {
      return state.fontSize
    },
    // get is mobile
    GET_IS_MOBILE: state => {
      return state.isMobile
    }
}

const mutations = {
    // update application runing state in store
    SET_APP_IS_RUNNING: (state, value) => {
        state.appIsRunning = value
    },

    // update the value of page scroll (y)
    SET_APP_SCROLL: (state, value) => {
        state.appScroll = value
    },

    // set font size to normal
    SET_FONT_SIZE: (state, value) => {
        state.fontSize = value
    },

    // set is mobile
    SET_IS_MOBILE: (state, value) => {
      state.isMobile = value
    }
}

export {
    state,
    getters,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js